import React, { useState } from 'react';

import { Button, Card } from 'antd';

import ApiTab from '../settings/ApiTab';

const ServicesPage = () => {
    const [showApi, setShowApi] = useState(false);

    return (
        <div>
            <div className="services-grid">
                <Card
                    title="API-доступ"
                    style={{ maxWidth: 520 }}
                >
                    <p style={{ color: '#8c8c8c', fontSize: 13, lineHeight: 1.5, marginTop: 0 }}>
                        Данные станций для внешних систем: подписка, ключи, документация, журнал обращений.
                    </p>
                    <Button type="primary" onClick={() => setShowApi((v) => !v)}>
                        {showApi ? 'Скрыть управление' : 'Управление API'}
                    </Button>
                </Card>
            </div>

            {showApi && (
                <Card style={{ marginTop: 16 }}>
                    <ApiTab />
                </Card>
            )}
        </div>
    );
};

export default ServicesPage;
